import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../ui/dialog';
import { CalendarDays, Loader2 } from 'lucide-react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

/**
 * Dialog for rescheduling a task to a different date.
 */
const RescheduleDialog = ({
  open,
  onOpenChange,
  task,
  rescheduleDate,
  setRescheduleDate,
  rescheduleReason,
  setRescheduleReason,
  onReschedule,
  actionLoading
}) => {
  const formatTaskDate = () => {
    if (!task?.date) return 'Non définie';
    try {
      return format(new Date(task.date), "EEEE d MMMM yyyy", { locale: fr });
    } catch (e) {
      return task.date;
    }
  };

  const getMinDate = () => {
    try {
      return format(new Date(), 'yyyy-MM-dd');
    } catch (e) {
      return '';
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CalendarDays className="h-5 w-5 text-blue-500" />
            Changer la date de prestation
          </DialogTitle>
        </DialogHeader>
        <div className="py-4 space-y-4">
          <p className="text-sm text-gray-600">
            Date actuelle : <strong>{formatTaskDate()}</strong>
          </p>
          <div className="space-y-2">
            <Label>Nouvelle date *</Label>
            <Input 
              type="date" 
              value={rescheduleDate} 
              onChange={(e) => setRescheduleDate(e.target.value)} 
              min={getMinDate()} 
              data-testid="reschedule-date-input" 
            />
          </div>
          <div className="space-y-2">
            <Label>Raison (optionnel)</Label>
            <Input 
              placeholder="Ex: Surcharge de travail..." 
              value={rescheduleReason} 
              onChange={(e) => setRescheduleReason(e.target.value)} 
              data-testid="reschedule-reason-input" 
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
          <Button 
            className="bg-[#003366] hover:bg-[#002244]" 
            onClick={onReschedule} 
            disabled={actionLoading || !rescheduleDate} 
            data-testid="confirm-reschedule-btn"
          >
            {actionLoading && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
            Changer la date
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RescheduleDialog;
